<template>
  <section class="mt-2" v-if="hasNoThai(message)">
    <div>
      <div>
        <a href="" @click.prevent="translateToThai(message)"><i class="fa-solid fa-language fa-sm"></i> แปลภาษา</a>
      </div>
      <div v-show="isTranslating">
        <i class="fa-solid fa-circle-notch fa-spin"></i>
      </div>
      <div v-if="tranlatedText">{{ tranlatedText }}</div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
export default {
  props: {
    message: String
  },
  data () {
    return {
      isTranslating: false,
      tranlatedText: null
    }
  },
  methods: {
    hasNoThai (text) {
      return !/[\u0E00-\u0E7F]/.test(text)
    },
    async translateToThai (text) {
      this.isTranslating = true
      this.tranlatedText = null
      const url = '/ai-assistant/translate-to-thai'
      const { data } = await axios.post(url, { user_input: text })
      this.isTranslating = false
      if (data) {
        this.tranlatedText = data.translatedText
      }
    }
  }
}
</script>
